import axios from 'axios';
const state= {
  template: {
    id: 0,
    name_checklist_templates: '',
    content_checklist_templates: [],
    index: 0
  },
  checklist_teamplates: {
    data: [],
    total: 0,
    filter: null
  },
  templateLoading: {
    listing: false
  },
  contractId: 0,
};

const getters = {
  checklistTeamplates : (state) => state.checklist_teamplates,
  templateLoading: (state) => state.templateLoading,
  templateItem: (state) => state.template,
  contractId : (state) => state.contractId,
};

const actions = {
  async setItemTemplate({commit}, params){
    commit('setTemplate', params)
  },
  async getListCheckListTemplate({commit}, params){
    return new Promise (( resolve, reject ) => {
      commit( 'setTemplateLoading', true )
      global.axios(`api/checklist-templates`, {
        method: "GET",
        params: {
          limit: params[0] || 50,
          page: params[1] || 1,
          filter: params[2] || ''
        },
        headers: {
          Accept: "application/json",
        }
      })
      .then(response => {
        if(response.data.status == 200) {
          response.data.data.filter = params[2] || null
          commit( 'setListCheckListTemplate', response.data.data );
        }
        commit( 'setTemplateLoading', false )
        resolve( response )
      })
      .catch(error => reject( error ));
    });
  },
  async searchTemplate({commit}, params){
    return new Promise (( resolve, reject ) => {
      commit( 'setTemplateLoading', true )
      global.axios(`api/checklist-templates`, {
        method: "GET",
        params: {
          limit: params[0] || 50,
          page: params[1] || 1,
          filter: params[2] || ''
        },
        headers: {
          Accept: "application/json",
        }
      })
      .then(response => {
        commit( 'setTemplateLoading', false )
        resolve( response )
      })
      .catch(error => reject( error ));
    });
  },
  async getItemTemplate({commit}, params){
    return new Promise (( resolve, reject ) => {
      global.axios(`api/checklist-templates/${params}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
        }
      })
      .then(response => {
        if(response.data.status == 200) {
          commit('setTemplate', response.data.data)
        }
        resolve( response )
      })
      .catch(error => reject( error ));
    });
  },
  async createTemplate({commit}, params){
    return new Promise (( resolve, reject ) => {
      global.axios(`api/checklist-templates`, {
        method: "POST",
        data: params,
        headers: {
          Accept: "application/json",
        }
      })
      .then(response => {
        if(response.data.status == 200) {
          commit('updateListCheckListTemplate', response.data.data)
        }
        resolve( response )
      })
      .catch(error => reject( error ));
    });
  },
  async updateTemplate({commit}, params){
    return new Promise (( resolve, reject ) => {
      global.axios(`api/checklist-templates/${params.id}`, {
        method: "PUT",
        data: params,
        headers: {
          Accept: "application/json",
        }
      })
      .then(response => {
        if(response.data.status == 200) {
          if(params.hasOwnProperty('index')) {
            response.data.data.index = params.index
          }
          commit('updateItemTemplate', response.data.data)
        }
        resolve( response )
      })
      .catch(error => reject( error ));
    });
  },
  async deleteTemplate({commit}, params){
    return new Promise (( resolve, reject ) => {
      commit( 'setTemplateLoading', true )
      global.axios(`api/checklist-templates`, {
        method: "DELETE",
        params: {
          ids: params
        },
        headers: {
          Accept: "application/json",
        }
      })
      .then(response => {
        commit( 'setTemplateLoading', false )
        resolve( response )
      })
      .catch(error => reject( error ));
    });
  },
  async uploadFileChecklistTemplate({commit}, params){
    return new Promise (( resolve, reject ) => {
        let formData = new FormData();
        formData.append('file_import',params.fileChecklistTemplate);
        global.axios.post(`api/checklist-templates/import`,formData,
        {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        })
        .then(response => {

          resolve( response );
        })
        .catch(error => reject( error ));
    });
  },
};

const mutations = {
  setListCheckListTemplate (state, data) {
    state.checklist_teamplates.data = data.items
    state.checklist_teamplates.total = data.total
    state.checklist_teamplates.filter = data.filter
  },
  setTemplateLoading (state, val) {
    state.templateLoading.listing = val
  },
  setTemplate (state, data) {
    state.template.id = data.id
    state.template.name_checklist_templates = data.name_checklist_templates
    state.template.content_checklist_templates = data.content_checklist_templates
    state.template.index = data.index || 0
  },
  updateItemTemplate (state, data) {
    if(data.hasOwnProperty('index')) {
      state.checklist_teamplates.data[data.index] = Object.assign({}, data)
    }
  },
  updateListCheckListTemplate (state, data){
    state.checklist_teamplates.data.push(data)
    state.checklist_teamplates.total += 1
  },
  setcontractId(state,val){
    state.contractId = val;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}